import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/index";
import Products from "@/components/products/index";
import proDetail from "@/components/products/detail";
import News from "@/components/news/index";
import articleDetail from "@/components/news/detail";
import About from "@/components/about/index.vue";
import Qiyejj from "@/components/about/qiyejianjie";
import Zizhiry from "@/components/about/zizhirongyu";
import Qiyexc from "@/components/about/qiyexiangce";
import Kehujz from "@/components/about/kehujianzheng";
import Jishuzc from "@/components/about/jishuzhichi";
import Changjianwt from "@/components/about/changjianwenti";
import Lianxiwj from "@/components/about/lianxiwanjie";
import search from "@/components/search.vue";
import map from "@/components/map.vue";
import anli from "@/components/case/index";
import anliList from "@/components/case/list";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  mode: "history", //去除#号
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
      meta: {
        intro: "index",
        seoname: "首页"
      }
    },
    {
      path: "/case",
      name: "case",
      component: anli,
      redirect: "/case/brand",
      children: [
        {
          path: "brand",
          name: "品牌企业案例",
          component: anliList,
          meta: {
            typeid: 22,
            seoname: "品牌企业案例"
          }
        },
        {
          path: "public",
          name: "公共食堂案例",
          component: anliList,
          meta: {
            typeid: 23,
            seoname: "公共食堂案例"
          }
        },
        {
          path: "monopoly",
          name: "专卖连锁案例",
          component: anliList,
          meta: {
            typeid: 24,
            seoname: "专卖连锁案例"
          }
        },
        {
          path: "individual",
          name: "个体工商户案例",
          component: anliList,
          meta: {
            typeid: 25,
            seoname: "个体工商户案例"
          }
        },
        {
          path: "customer",
          name: "客户案例",
          component: anliList,
          meta: {
            typeid: 20,
            seoname: "客户案例"
          }
        }
      ]
    },
    {
      path: "/products/:name",
      name: "products",
      component: Products,
      meta: {
        intro: "products"
      }
    },
    {
      path: "/product/:type/:id.html",
      name: "prodetail",
      component: proDetail,
      meta: {
        intro: "products"
      }
    },
    {
      path: "/search",
      name: "search",
      component: search
    },
    {
      path: "/map",
      name: "map",
      component: map
    },
    {
      path: "/news/:name",
      name: "news",
      component: News,
      meta: {
        intro: "news"
      }
    },
    {
      path: "/newsdetail/:classid/:from:id.html",
      name: "文章详情",
      component: articleDetail
    },
    {
      path: "/about",
      name: "about",
      component: About,
      redirect: "/about/intro",
      children: [
        {
          path: "intro",
          name: "企业简介",
          component: Qiyejj,
          meta: {
            intro: "about",
            seoname: "企业简介"
          }
        },
        {
          path: "honor",
          name: "资质荣誉",
          component: Zizhiry,
          meta: {
            intro: "about",
            seoname: "资质荣誉"
          }
        },
        {
          path: "album",
          name: "企业相册",
          component: Qiyexc,
          meta: {
            intro: "about",
            seoname: "企业相册"
          }
        },
        // {
        //   path: 'customer',
        //   name: '客户见证',
        //   component: Kehujz,
        //   meta: {
        //     intro: 'customer',
        //     seoname: '客户见证'
        //   }
        // },
        {
          path: "support",
          name: "技术支持",
          component: Jishuzc,
          meta: {
            intro: "about",
            seoname: "技术支持"
          }
        },
        {
          path: "problem",
          name: "常见问题",
          component: Changjianwt,
          meta: {
            intro: "about",
            seoname: "常见问题"
          }
        },
        {
          path: "contanct",
          name: "联系万杰",
          component: Lianxiwj,
          meta: {
            intro: "contanct",
            seoname: "联系万杰"
          }
        }
      ]
    },
    {
      path: "*",
      name: "index",
      component: Index,
      meta: {
        intro: "index",
        seoname: "首页"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js